import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { BlanchingCookingDto } from './blanching-cooking.dto';

export class BlanchingCookingReponseModel extends GlobalResponseObject{
    data?: BlanchingCookingDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: BlanchingCookingDto){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }

}